import React from "react"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Layout from "../components/layout"
import SEO from "../components/seo"
/*import Safe from "react-safe"*/
import Reviews from "../components/reviews"

class IndexPost extends React.Component {

  render() {

    const { data } = this.props;
    console.log(data);

    return (
      <React.Fragment>
        <div className="row product-main">
          {data.data.allCategory.nodes.map(items => (
            <div className="Catalogue__item col-sm-12 col-md-6 col-lg-4" key={items.id}>
              <div className="details_List">


                <Link to={`/${items.slug}`}>

                  { items.image && items.image[0] ? <Img fluid={{
                      "src": `${process.env.GATSBY_FLOTIQ_BASE_URL}/image/1920x0/${items.image[0].id}.${items.image[0].extension}`,
                      "aspectRatio": 1.77,
                      "fluid": '',
                      "srcSet": ''
                  }} /> : <div className="no-image">No Image</div>}

                </Link>


                  <div className="details_inner">

                  <h2>
                    <Link to={`/${items.slug}`}>{items.name}</Link>
                  </h2>
                </div>
              </div>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

const IndexPage = data => (

  <Layout>
    <SEO title="Patty's Homemade Gifts" ogTitle="Patty's Homemade Gifts" ogURL="https://pattyshomemadegifts.com" ogDescription="Need a special gift? All my items are handmade, and made to last." ogImage="http://pattyshomemadegifts.com/homeOG.jpg" keywords={[`Handmade`, `Crafts`, `hand sanitizer pouch`, 'bags', 'embroidered', 'embroidered canvas', 'tote bags', 'embroidered canvas tote bags', 'hooded towels', 'hooded towel', 'dog walking bags', 'crayon bags', 'crochet', 'crocheted', 'stuffed animals', 'crocheted stuffed animals']} />
    <div className="container">
      <div className="text-center"><h1 className="with-underline">Welcome To Patty’s Homemade Gifts</h1></div>
      <p className="home-top-p">All my items are handmade and some can also be personalized with a name, date, occasion etc.  I will be glad to work with you on a special request.  We can chat live or use my Contact link to email me and I will get right back to you.</p>
      <div className="text-center"><h2>Categories</h2></div>
      <IndexPost data={data} />
    </div>
{/*    <div className="col-sm-12 center reviews-slider">
      <div className="reviews-slider">
        <Safe.script src="https://apps.elfsight.com/p/platform.js"></Safe.script>
        <div className="elfsight-app-e3921957-c47a-47ab-afaa-a43692fed62a"></div>
      </div>
    </div>*/}
    <h2 className="text-center">My Reviews</h2>
    <Reviews data={data} />
  </Layout>
)

export default IndexPage

export const query = graphql`
  query AboutQuery {

    allCategory(sort: {fields: position, order: ASC}) {
      nodes {
        id
        image {
          extension
          id
        }
        name
        slug
        description
        position
      }
    }

    allReviews(sort: {fields: flotiqInternal___createdAt, order: DESC}) {
      nodes {
        reviewDate
        reviewerName
        reviewContent
        reviewProduct
      }
    }

  }
`



